import { Component, Inject, OnInit, Renderer2, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { AddService } from 'src/app/shared/services/userservices/add.service'
import { Router, RouterModule } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

declare let $: any;
interface User {
  id: number;
  first_name: string;
  last_name: string;
  user_roles: string;
  // userRolesArray: string[];
}
@Component({
  selector: 'app-employee-payroll-managment',
  templateUrl: './employee-payroll-managment.component.html',
  styleUrls: ['./employee-payroll-managment.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent]
})
export class EmployeePayrollManagmentComponent implements OnInit, AfterViewInit {
  @ViewChild('confirmModal') confirmModal!: ElementRef;
  public user: any = [];
  public seleted_user: any;
  // public  user_uuid:any=[];
  public usersList: any[] = [];
  public mobileTeam: any[] = [];
  public webTeam: any[] = [];
  public graphicTeam: any[] = [];
  public sqaTeam: any[] = [];
  public managementTeam: any[] = [];
  public managementLead: any[] = [];
  public businessTeam: any[] = [];
  public teamLead: any[] = [];
  public others: any[] = [];
  public superBoy: any[] = [];
  public toggleUserId: any;
  public toggleUserStatus: any = 1;
  public temp_usersList: any[] = [];
  loannotification: any = {};
  lonecount: any;
  public showSpinner = true;
  public departmentNames: any;
  department: string | undefined;
  usersRoles: any;
  roleType: any;
  apidata: any;
  uuid: any;
  password: any;
  newPasswordInput: any;
  newPassword: any;
  newemployee_status: any;
  employee_status: any;
  employeeStatus: any;
  statuses: any;
  team_lead = false;
  isCurrentEmployee = true;
  isoldEmployee = false;
  userRoles: any;
  userRolesArray: any[] = [];
  departmentuserSRole: any[] = [];
  oldUsersList: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  refresh: any;
  card_name: any;
  currentPage: any;
  totalPages: any;
  departmentNames1: any;
  usershittime: any;
  WFH: any;
  workfromhome: any;
  wfhModalValueTracker = false;
  modalTrackerCheckBoxHide = true;
  trackerForModal: any;
  userNameForModal: any;
  isExEmployeeLoaded = false;
  isStatusForEditLoaded = false;
  user_role: any;

  constructor(
    private renderer: Renderer2,
    private http: HttpClient,
    public _location: Location,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,

    @Inject(AddService) private addService: AddService,
    public router: Router) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.roleType = this.user_role?.role_type;
    if (this.roleType == 'Employee') {
      this.router.navigate(['/dashboard-1']);
    }

  }


  deleteModal(user: any) {
    this.seleted_user = user
    const modalDiv = document.getElementById('deleteModal');
    if (modalDiv != null) {
      modalDiv.style.display = 'block';
    }

  }
  retrivedModal(user: any) {
    this.seleted_user = user
    const modalDiv = document.getElementById('retrivedModal');
    if (modalDiv != null) {
      modalDiv.style.display = 'block';
    }

  }
  selectedUserUUID: any;

  setUserUUID(uuid: string) {
    this.selectedUserUUID = uuid;
  }
  quickEditeModal(user: any) {
    this.seleted_user = user
    const modalDiv = document.getElementById('quickEditeModal');
    if (modalDiv != null) {
      modalDiv.style.display = 'block';
    }
  }

  UserDelete() {
    this.showSpinner = true;
    this.addService.deleteUser(this.seleted_user.uuid).then((value) => {
      this.showSpinner = false;
      window.location.reload();
    });
  }


  UserRetrived() {
    this.showSpinner = true;
    this.addService.retrivedUser(this.seleted_user.uuid).then((value) => {
      this.showSpinner = false;
      window.location.reload();
    });
  }
  UserUpdate(uuid: string) {
    this.router.navigate(['/employee-add/', uuid]);
    this.addService.updateUser(uuid).then((value) => {
    });
  }
  ngOnInit(): void {
    this.getData();
    this.Loannotificaton(this.lonecount)
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });

  }





  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  removed(removed: any) {
    throw new Error('Method not implemented.');
  }
  getstatusData() {

    if (!this.isStatusForEditLoaded) {
      this.showSpinner = true
      this.addService.getStaticData().then((value) => {
        this.showSpinner = false;
        this.statuses = value.data.employeeTypes;
        this.isStatusForEditLoaded = true;
      })
    }

  }
  getUserdata(uuid: any) {
    this.getstatusData();

    this.selectedUserUUID = uuid;
    this.addService.updateUser(uuid).then((value) => {
      this.apidata = value?.data

    });

  }
  getData(department = '', page = 1) {
    // user_roles check karna api after runinng muneeb 23.06.2025
    this.showSpinner = true;
    this.dashboardService.getUserList().then((value) => {
      this.showSpinner = false;
      this.usersList = value.data;
      // Get the department names
      this.departmentNames = Object.keys(this.usersList);
      //     this.currentPage[department] = page;
      // this.totalPages[department] = value.totalPages;

      // Sort and process user roles

      for (const departmentName in this.usersList) {
        if (this.usersList.hasOwnProperty(departmentName)) {
          const usersInDepartment = this.usersList[departmentName];
          usersInDepartment.sort(compareUsers);

          this.departmentuserSRole = [];

          // Process users in the department
          for (const user of usersInDepartment) {
            try {
              if (user?.user_role?.user_roles) {
                const userRoles = JSON.parse(user.user_role.user_roles);
                this.departmentuserSRole.push(userRoles.role_type);
              }
              this.card_name = user.card_name;
              user.backgroundImage = this.getBackgroundImage(user.department, user.card_name);
            } catch (error) {
              console.error("Error parsing user roles:", error);
            }
          }
          this.userRolesArray.push(this.departmentuserSRole);
        }
      }

      // Define the User interface
      interface User {
        id: number;
        first_name: string;
        last_name: string;
        user_roles: string;
        card_name: string;
        backgroundImage?: string;
      }

      // Function to compare users based on their role_type
      function compareUsers(a: User, b: User): number {
        const roleOrder = ["Admin_AND_Team_Lead", "Admin", "Team_Lead", "Employee"];
        const roleA = a.user_roles ? JSON.parse(a.user_roles).role_type : "Employee";
        const roleB = b.user_roles ? JSON.parse(b.user_roles).role_type : "Employee";
        const indexA = roleOrder.indexOf(roleA);
        const indexB = roleOrder.indexOf(roleB);

        if (indexA === -1 && indexB === -1) {
          return roleA.localeCompare(roleB);
        }
        if (indexA === -1) {
          return 1;
        }
        if (indexB === -1) {
          return -1;
        }
        return indexA - indexB;
      }

    });

  }


  // Method to convert time from 24-hour to 12-hour format
  convertTo12Hour(time: string): string {
    if (time) {
      const [hours, minutes] = time.split(':').map(Number);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const adjustedHours = hours % 12 || 12; // convert 0 to 12 for 12 AM/PM
      return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    }
    return "00:00"; // default value for null or invalid time
  }

  onPageChange(department: string, page: number) {
    this.getData(department, page);
  }
  // old user
  getolduser(removed: any) {
    if (!this.isExEmployeeLoaded) {
      this.showSpinner = true;
      removed = 1
      this.dashboardService.getOldList(removed).then((value) => {
        this.showSpinner = false;
        this.oldUsersList = value.data;
        this.isExEmployeeLoaded = true;
        this.departmentNames1 = Object.keys(this.oldUsersList);
        //     this.currentPage[department] = page;
        // this.totalPages[department] = value.totalPages;

        // Sort and process user roles

        for (const departmentName in this.oldUsersList) {
          if (this.oldUsersList.hasOwnProperty(departmentName)) {
            const usersInDepartment = this.oldUsersList[departmentName];
            usersInDepartment.sort(compareUsers);

            this.departmentuserSRole = [];

            // Process users in the department

            for (const user of usersInDepartment) {
              try {
                user.backgroundImage = this.getBackgroundImage(user.department, user.card_name);
              } catch (error) {
                console.error("Error parsing user roles:", error);
              }
            }
            // this.userRolesArray.push(this.departmentuserSRole);
          }
        }
        interface User {
          id: number;
          first_name: string;
          last_name: string;
          user_roles: string;
          card_name: string;
          backgroundImage?: string;
        }

        // Function to compare users based on their role_type
        function compareUsers(a: User, b: User): number {
          const roleOrder = ["Admin_AND_Team_Lead", "Admin", "Team_Lead", "Employee"];
          const roleA = a.user_roles ? JSON.parse(a.user_roles).role_type : "Employee";
          const roleB = b.user_roles ? JSON.parse(b.user_roles).role_type : "Employee";
          const indexA = roleOrder.indexOf(roleA);
          const indexB = roleOrder.indexOf(roleB);

          if (indexA === -1 && indexB === -1) {
            return roleA.localeCompare(roleB);
          }
          if (indexA === -1) {
            return 1;
          }
          if (indexB === -1) {
            return -1;
          }
          return indexA - indexB;
        }

      });
    }
  }


  getBackgroundImage(department: string, cardName: string): string {
    // Check if cardName has a specific image
    if (this.cardImageMappings[cardName]) {
      return this.cardImageMappings[cardName];
    }
    // Default background image based on department
    return this.departmentBackgrounds[department] || '';
  }




  departmentBackgrounds: Record<string, string> = {
    'Higher Management': '../../../assets/images/test-bg.png',
    'Human Resource Managment': '../../../assets/images/s-bg.png',
    'Team Leads': '../../../assets/images/t-bg.png',
    'Business Development': '../../../assets/images/mobile-bg.png',
    'Web Application Development': '../../../assets/images/mobile-bg.png',
    'Mobile Application Development': '../../../assets/images/mobile-bg.png',
    'Graphic Designers': '../../../assets/images/mobile-bg.png',
    'Quality Insurance': '../../../assets/images/mobile-bg.png',
    'Demo Users': '../../../assets/images/mobile-bg.png',
    'Office Boys': '../../../assets/images/mobile-bg.png',
  };
  cardImageMappings: Record<string, string> = {
    'TEAM_LEAD_CARD': '../../../assets/user-cards/1.svg',
    'MANAGER_CARD': '../../../assets/user-cards/2.svg',
    'DEMO_CARD': '../../../assets/user-cards/3.svg',
    'HR_CARD': '../../../assets/user-cards/4.svg',
    'ADMIN_CARD': '../../../assets/user-cards/5.svg',
    'FACUTY_CARD': '../../../assets/user-cards/6.svg',
    'ADMIN_TEAM_LEAD_CARD': '../../../assets/user-cards/7.svg',
    'FACULTY_MANAGER_CARD': '../../../assets/user-cards/8.svg',
    'MANAGMENT_CARD': '../../../assets/user-cards/9.svg',
    'HUMAN_RESOURCE_CARD': '../../../assets/user-cards/10.svg',
    'SUPERADMIN_CARD': '../../../assets/user-cards/11.svg',
    'OFFICE_FACUTY_CARD': '../../../assets/user-cards/12.svg'
  };
  getFooterImages(department: string): string[] {
    // Define mappings for footer images based on department name
    const footerImageMappings: Record<string, string[]> = {
      'Higher Management': ['lnkd.png', 'fb.png', 'inst.png'],
      'Human Resource Managment': ['s-lnkd.png', 's-fb.png', 's-inst.png'],
      'Team Leads': ['lnkd-t.png', 'fb-t.png', 'inst-t.png'],
      'Business Development': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Web Application Development': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Mobile Application Development': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Graphic Designers': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Quality Insurance': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Demo Users': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Office Boys': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],



      // Add mappings for other departments
    };

    // Return the appropriate images for the department
    return footerImageMappings[department] || [];
  }



  isOthersDaata(): boolean {
    if (this.teamLead.length == 0) {
      return false
    } else {
      return true
    }
  }

  getWFH(userId: any, userStatus: Event, tracker: any) {
    // this.dashboardService.getWFH(userId, userStatus, tracker).then((value) => {
    // });
    this.dashboardService.getWFH(userId, userStatus, tracker).then((response: any) => {
      if (response && response.success === true) {
        window.location.reload();
      } else {
        console.warn('WFH update failed or was not successful:', response);
      }
    }).catch(error => {
      console.error('Error in getWFH:', error);
    });
  }
  selectedUserId: number | null = null;
  lastToggleElement: HTMLInputElement | null = null;
  toggleValue = false;
  ngAfterViewInit() {
    $('#confirmModalss').on('hidden.bs.modal', () => {
      if (this.lastToggleElement) {
        // Revert the toggle
        this.lastToggleElement.checked = !this.toggleValue;
      }

      // Clear references
      this.lastToggleElement = null;
      this.selectedUserId = null;
    });
  }
  toggleClick(user: any, event: Event, toggleRef: HTMLInputElement) {
    event.preventDefault(); // prevent toggle immediately
    this.lastToggleElement = toggleRef;
    this.toggleUserId = user.id;
    this.userNameForModal = user.first_name + ' ' + user.last_name;
    // Detect current checked state
    const isChecked = toggleRef.checked;
    this.toggleValue = isChecked; // store current state for reference

    // Save intended WFH status
    this.toggleUserStatus = isChecked ? 1 : 0;

    // Set current Tracker value from user
    this.wfhModalValueTracker = user.tracker == 1 ? true : false;
    // Show modal
    $('#confirmModalss').modal('show');
  }
  modalClick(value: boolean) {
    const newStatus = this.toggleValue ? 1 : 0;
    // this.modalTrackerCheckBoxHide = value;

    if (value == true) {
      this.wfhModalValueTracker = value;
      // this.wfhModalValueTracker=1;
      // this.modalTrackerCheckBoxHide = false;
      // this.modalTrackerCheckBoxHide = value;

    } else {
      // this.modalTrackerCheckBoxHide = true;
      // this.wfhModalValueTracker = false;
      // this.modalTrackerCheckBoxHide = value;
      this.wfhModalValueTracker = value;
    }
    this.getWFH(this.toggleUserId, this.toggleUserStatus, this.wfhModalValueTracker);
    $('#confirmModalss').modal('hide');
  }
  modalClickChangeValues() {
    const newStatus = this.toggleValue ? 1 : 0;

    this.wfhModalValueTracker = false;
    this.toggleUserStatus = 0;

    this.getWFH(this.toggleUserId, this.toggleUserStatus, this.wfhModalValueTracker);
    $('#confirmModalss').modal('hide');
  }
  onSubmit(f: NgForm) {
    this.showSpinner = true;
    const name = f.value.name_search ?? ''
    const emp_id = f.value.employee_id ?? ''
    const email = f.value.email_search ?? ''
    if (name.length > 0 || email.length > 0 || emp_id.length > 0) {

      this.usersList = []
      this.temp_usersList.forEach((obj: any) => {
        if (name.length > 0) {
          if (obj.first_name.toLowerCase().includes(name.toLowerCase()) || obj.last_name.toLowerCase().includes(name.toLowerCase())) {
            this.usersList.push(obj)
          }
        } else if (emp_id.length > 0) {
          if (obj.attendance_user_id == emp_id) {
            this.usersList.push(obj)
          }
        } else if (email.length > 0) {
          if (obj.email.toLowerCase().includes(email.toLowerCase())) {
            this.usersList.push(obj)
          }
        }
      });
      this.showSpinner = false;
    } else {
      this.showSpinner = false;
      this.usersList = this.temp_usersList;
    }

  }



  showCurrentEmployee() {
    this.isCurrentEmployee = true;
    this.isoldEmployee = false;
  }
  // tabs funtion
  showoldEmployee() {

    this.getolduser(this.removed);
    this.isCurrentEmployee = false;
    this.isoldEmployee = true;

  }

  onReset(f: NgForm) {
    f.reset()
    this.usersList = this.temp_usersList;
  }



  showDetails(user: any) {
    const role = this.user.user_role.user_roles
    const userRoles = JSON.parse(role);
    const monthlySalary = userRoles.team_managment.data.values.view;
    if (monthlySalary == true) {
      const name = user.first_name + " " + user.last_name
      this.router.navigate(['/employee-payrolls-detail', { 'user_id': user.id, 'user_name': name, 'designation': user.description }]);
    }

  }
  childClick(event: any) {
    event.stopPropagation();
  }


  monthlySalary() {
    const selected_date = (document.getElementById("salary_month") as HTMLInputElement).value;
    if (selected_date == null || selected_date.length == 0) {
      return
    }
    this.router.navigate(['/employee-monthly-salary', { 'selected_date': selected_date }]);
  }
  addNewUserBtn() {
    this.router.navigate(['/employee-add']);
  }
  loanReport() {
    this.router.navigate(['/loan-report']);
  }
  isavailablefeature(type: string): boolean {
    
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.team_managment?.data?.values;
    switch (type) {
      case "isView":
        return values.view ?? false
      case "isAddUser":
        return values.add ?? false
      case "isMothySalary":
        return values.monthly_salary ?? false
      case "isDeleteUser":
        return values.delete ?? false
      case "isUpdateUser":
        return values.updateUser ?? false
      case "isloanReport":
        return values.loanView ?? false
      case "isWFH":
        return values.update ?? false
      case "isTeamlead":
        return !(this.user.department == 'Team Leads' ? true : false)
      default:
        return false;
    }
    return false
  }
  updateStatus(statusUpdate: NgForm) {
    this.uuid = this.apidata.uuid

    const status = statusUpdate.value.employee_type
    this.addService.updateStatus(this.uuid, status).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Status Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }



  updatePassword(passwordUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const password = passwordUpdate.value.password
    this.addService.updatePassword(this.uuid, password).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Password Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }

  updateShiftTime(ShiftTimeUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const startTime = ShiftTimeUpdate.value.startTime
    const endTime = ShiftTimeUpdate.value.endTime
    this.addService.updateShiftTime(this.uuid, startTime, endTime).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Shift Time Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });

  }

  updateAccount(accountUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const accountNo = accountUpdate.value.ac_number
    this.addService.updateAccountNo(this.uuid, accountNo).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Account No Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }


  updateSalary(salaryUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const salary = salaryUpdate.value.newSalary
    const taxSalary = salaryUpdate.value.salaryTax
    this.addService.updateSalary(this.uuid, salary, taxSalary).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Salary Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }


  Loannotificaton(lonecount: any) {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type != "Team_Lead") {
      this.lonecount = "loan_request";
      this.addService.loanNotify(this.lonecount).then((value) => {

        this.loannotification = value.data
      })
    }
  }
  isWFHAllowed(user: any): boolean {
    const dayIndex = 0;
    if (user.todays_usershittime?.[dayIndex]?.work_from_home == '1' || (user.attandance_type != 'Normal')) {
      return true;
    }
    return false;
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

  // account check
  restrictInputToAccounts(event: Event) {
    const input = event.target as HTMLInputElement;
    let inputValue = input.value;

    const modifiedValue = inputValue.replace(/[^0-9-]/g, '').replace(/-{2,}/g, '-');

    const firstHyphenIndex = modifiedValue.indexOf('-');
    const lastHyphenIndex = modifiedValue.lastIndexOf('-');

    if (firstHyphenIndex !== lastHyphenIndex) {
      const hyphenRemovedValue = modifiedValue.substring(0, lastHyphenIndex) +
        modifiedValue.substring(lastHyphenIndex + 1);
      inputValue = hyphenRemovedValue;
    } else {
      inputValue = modifiedValue;
    }

    if (inputValue !== input.value) {
      input.value = inputValue;
      input.dispatchEvent(new Event('input'));
    }
  }

}
